<template><ListFilter field="structure_i" :options="opts" label="Структура I порядка" @filter="$emit('filter',$event)" @openDetail="$emit('openDetail',$event)"/></template>
<script>
import ListFilter from './ListFilter.vue'
export default { name:'StructureIFilter', components:{ListFilter}, data(){ return { opts:['Башкирский свод','Демьянский мегавал','Жигулевско-Оренбургский свод','Мелекесская впадина','Покровско-Сорочинская зона поднятий','Предуральский краевой прогиб','Уренгойский мегавал','Харьягинский вал','Южно-Татарский свод'] } } }
</script>
